angular.
module("dx.webapp.student").
controller("DxChangeStudentCodeRouteController", function DxChangeStudentCodeRouteController(
	dxApi,
	validationService,
	ngPasteFromErrors
) {
	"use strict";

	var self = this;

	self.studentInputData = [];
	self.error = null;
	self.isLoading = false;
	self.isCodesChanged = false;
	self.isValidated = false;
	self.filteredStudentInputData = [];
	self.filteredStudentInputDataErrors = [];

	self.onBeforePaste = function onBeforePaste(data) {
		self.error = null;
		self.isCodesChanged = false;
		self.isValidated = false;

		return data;
	};

	self.onValidateEntry = function onValidateEntry(row) {
		var email = row.email.trim();
		var studentCode = row.studentCode.trim();

		var isEmailValid = validationService.isEmailValid(email);
		if (!isEmailValid) {
			self.error = "Current e-mail is not valid: " + email;
		}

		var isStudentCodeValid = validationService.isStudentCodeValid(studentCode);
		if (!isStudentCodeValid) {
			self.error = "Student Code for " + email + " is not valid: " + studentCode;
		}

		return isEmailValid && isStudentCodeValid;
	};

	self.onEntryError = function onEntryError(error, rowData) {
		if (error === ngPasteFromErrors.invalidColumnLength) {
			self.error = "Expected column length to be " + rowData.expectedLength;
		}
	};

	self.bulkChangeStudentCodes = function bulkChangeStudentCodes(execute) {
		self.isLoading = true;

		var payload = {
			studentInputData: self.studentInputData,
		};
		dxApi.v1.students.bulkChangeStudentCodes(execute, payload).then(onBulkChangeEmailSuccess, onBulkChangeEmailError);

		function onBulkChangeEmailSuccess(response) {
			if (execute) {
				self.isCodesChanged = true;
				resetInputData();
			} else {
				self.isValidated = true;
				self.filteredStudentInputData = response.data.invalid.studentInputData;
				self.filteredStudentInputDataErrors = response.data.errors;
				self.studentInputData = response.data.valid.studentInputData;
			}
			self.isLoading = false;
		}

		function onBulkChangeEmailError(response) {
			self.error = response.data.message;
			self.isLoading = false;
		}
	};

	function resetInputData() {
		self.filteredStudentInputData = [];
		self.filteredStudentInputDataErrors = [];
		self.studentInputData = [];
	}
});
